
    import { Rating } from '@alifd/next';
    import type { RatingProps } from '@alifd/next/types/rating';
    import wrapper from './next-wrapper';

    export type BLProFormRatingProps =RatingProps;

    const BLProFormRating = wrapper<BLProFormRatingProps>(Rating, 'BLProFormRating');

    export default BLProFormRating;
